import React from 'react';
import Button from '@material-ui/core/Button';
import { useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import Video from './Video';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '30px',
    color: theme.palette.secondary.main,
    fontFamily: 'Comfortaa',
    cursor: 'pointer',
  },
  logo: {
    width: '20px',
    cursor: 'pointer',
    position: 'absolute',
    marginLeft: (props) => (props.workspace?.custom_logo ? '-125px' : '-85px'),
    marginTop: (props) => (props.workspace?.custom_logo ? '-30px' : '-30px'),
  },
  
  videoContainer: {
    position: 'relative',
    width: '100%',
    paddingTop: '42.1875%', // 16:9 aspect ratio (height = width * 9/16)
    marginBottom: '20px',
  },
  startButton: {
    marginTop: '20px',
  },
}));

export default function Video_overlay(props) {
  const theme = useTheme();
  const classes = useStyles(props);

  if (props.workspace === undefined) {
    return null;
  }

  return (
    <Backdrop open={true} style={{ zIndex: 999999, backgroundColor: 'rgba(0, 0, 0, 0.8)'}}>
      <div style={{ width: '90vw', maxWidth: '900px', padding: '20px', position: 'relative', textAlign: 'center' }}>
        <div className={classes.videoContainer}>
          <Video style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}} video={props.video} autoplay/>
        </div>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', marginBottom: '40px' }}>
          <Button variant="contained" color="secondary" size="large" style={{ marginTop: '20px' }} onClick={() => { if(props.action!=undefined){window.location.href=props.action;}else{window.location.href ='/';} }}>Start Exploring</Button>
        </div>
      </div>
    </Backdrop>
  );
}
